export default {
    getReadWidget:   () => '<in-template-column entry="::entry" field="::field" entity="::entity"></in-template-column>',
    getLinkWidget:   () => '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>',
    getFilterWidget: () => '<ma-template-field field="::field" value="value" values="values" filters="filters"></ma-template-field>',
    getWriteWidget:  () => '<ma-template-field field="::field" value="value" entry="entry" entity="::entity"></ma-template-field>'
};



// WEBPACK FOOTER //
// ./app/components/common/crud/fieldView/TemplateFieldView.js